import { render, staticRenderFns } from "./addConfig.vue?vue&type=template&id=dd56a410&"
import script from "./addConfig.vue?vue&type=script&lang=js&"
export * from "./addConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd56a410')) {
      api.createRecord('dd56a410', component.options)
    } else {
      api.reload('dd56a410', component.options)
    }
    module.hot.accept("./addConfig.vue?vue&type=template&id=dd56a410&", function () {
      api.rerender('dd56a410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/performancecenter/theater/addConfig.vue"
export default component.exports